import api from "../api";

const api_type = 'v1'

export const GetNormPage = params => { return api.post(api_type+`/analysis_norm/page`, params) }
export const AddNorm = params => { return api.post(api_type+`/analysis_norm/add`, params) }
export const EditNorm = params => { return api.post(api_type+`/analysis_norm/edit`, params) }
export const DeleteNorm = params => { return api.post(api_type+`/analysis_norm/delete`, params) }
export const GetNormList = params => { return api.post(api_type+`/analysis_norm/list`, params) }

export const AddPanel = params => { return api.post(api_type+`/analysis_panel/add`, params) }
export const DeletePanel = params => { return api.post(api_type+`/analysis_panel/delete`, params) }
export const GetPanelList = params => { return api.post(api_type+`/analysis_panel/list`, params) }
export const GetPanel = params => { return api.post(api_type+`/analysis_panel/info`, params) }
export const GetAnalysis = params => { return api.post(api_type+`/analysis/data`, params) }
export const GetAnalysisBase = params => { return api.post(api_type+`/analysis/data_base`, params) }

export const GetNormAuthPage = params => { return api.post(api_type+`/analysis_norm_auth/page`, params) }
export const AddNormAuth = params => { return api.post(api_type+`/analysis_norm_auth/add`, params) }
export const DeleteNormAuth = params => { return api.post(api_type+`/analysis_norm_auth/delete`, params) }



// WEBPACK FOOTER //
// ./src/api/v1/analysis.js